import { type PortableTextMarkComponentProps } from '@portabletext/react'
import cx from 'classnames'

import { type SanityFrameBuilderBlockColoredText } from '@frame-builder/data/sanity/queries/types/content'

type ColoredTextValue = SanityFrameBuilderBlockColoredText

const colorClasses: Record<string, string> = {
  white: 'text-white',
  black: 'text-black',
}

const ColoredText = ({
  value,
  children,
}: PortableTextMarkComponentProps<ColoredTextValue>) => {
  return (
    <span
      className={cx(value?.color ? colorClasses[value.color] : '', {
        'opacity-50': !!value?.faded,
      })}
    >
      {children}
    </span>
  )
}

export default ColoredText
